<template>
  <div class="hero-wrapper">
    <v-container>
      <div>
        <h1>Professional Resource Center</h1>
        <p>
          A resource directory designed for financial advisors to discover quality solutions for their business needs.
        </p>
      </div>
    </v-container>
    <div class="img-wrapper">
      <img src="~@/modules/resource/assets/hero-books.jpg" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProvidersListHero',
}
</script>

<style lang="scss" scoped>
.hero-wrapper {
  position: relative;
  background-color: $accentBlue;

  .img-wrapper {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;

    @include lg { display: block; }

    img {
      height: 100%;
      width: auto;
      max-width: 65vw;
      margin-left: auto;
      clip-path: polygon(220px 0%, 100% 0%, 100% 100%, 110px 100%);
    }
  }

  .container {
    padding-top: 30px;
    padding-bottom: 30px;

    div {
      max-width: 80%;

      @include lg {
        max-width: 460px;
      }
    }

    position: relative;
    z-index: 2;
  }

  h1 {
    margin-bottom: 5px;
    color: white;
    text-transform: uppercase;
  }

  p {
    margin-bottom: 0;
    color: white;
    font-size: 20px;
    line-height: 26px;
  }
}
</style>
